import {useEffect, useState} from "react";
import {configureAmplify} from "../utils/amplifyConfig";

export const LOCAL_STORAGE_CLIENT_ID_KEY = "amplify_client_id";

export const applyAmplifyClientId = (clientId: string) => {
  localStorage.setItem(LOCAL_STORAGE_CLIENT_ID_KEY, clientId);
  configureAmplify(clientId);
};

export const useAmplifyConfig = (clientId?: string) => {
  const [isInitiated, setIsInitiated] = useState<boolean>(false);
  const rememberMe = localStorage.getItem("rememberMe");
  useEffect(() => {
    if (clientId) {
      applyAmplifyClientId(clientId);
      setIsInitiated(true);
      return;
    }
    const savedClientId = localStorage.getItem(LOCAL_STORAGE_CLIENT_ID_KEY);
    // if (rememberMe === "false") {
    //   cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
    // }
    if (savedClientId) {
      configureAmplify(savedClientId);
    }
    setIsInitiated(true);
  }, [clientId, rememberMe]);

  return isInitiated;
};
